import { defineMessages } from 'react-intl';

export default defineMessages({
  dateRange: 'Date range',
  funnels: 'Funnels',
  funnel: 'Funnel',
  createFunnel: 'Create funnel',
  editFunnel: 'Edit funnel',
  editFunnelStep: 'Edit funnel step',
  steps: 'Steps',
  addStep: 'Add step',
  noFunnels: 'No funnels',
});
